/*
*   List of Actions with TYPE that should be passed from accreditation.reducer.js to editor.reducer.js
 */
export const PREFIX = 'ACCREDITATION_SETTINGS';

export const TYPES = {
    SCHEME_DETAILS_REFRESH:             `${PREFIX}_SCHEME_DETAILS_REFRESH`,
    SCHEME_STATUS_REFRESH:              `${PREFIX}_SCHEME_STATUS_REFRESH`,

    REQUIREMENT_DETAILS_REFRESH:            `${PREFIX}_REQUIREMENT_DETAILS_REFRESH`,

    HOF_DOC_DETAILS_REFRESH:            `${PREFIX}_HOF_DOC_DETAILS_REFRESH`,
    HOF_DOC_DETAILS_RESET:              `${PREFIX}_HOF_DOC_DETAILS_RESET`,

    SLO_DOC_DETAILS_REFRESH:            `${PREFIX}_SLO_DOC_DETAILS_REFRESH`,
    SLO_DOC_DETAILS_RESET:              `${PREFIX}_SLO_DOC_DETAILS_RESET`,
    SLO_DOCS_LOCATION_SELECTS_RESET:    `${PREFIX}_SLO_DOCS_LOCATION_SELECTS_RESET`,

    DOCUMENT_SAMPLE_DOC_CHANGED:        `${PREFIX}_DOCUMENT_SAMPLE_DOC_CHANGED`,

    FETCH_ASS_HOF_SCHEME_HEAD_OFFICES:  `${PREFIX}_FETCH_ASS_HOF_SCHEME_HEAD_OFFICES`,
    ASS_HOF_SELECT_HEAD_OFFICE:         `${PREFIX}_ASS_HOF_SELECT_HEAD_OFFICE`,
    FETCH_NOT_ENABLED_HEAD_OFFICES:     `${PREFIX}_FETCH_NOT_ENABLED_HEAD_OFFICES`,
    SELECTED_HEAD_OFFICE_RESET:         `${PREFIX}_SELECTED_HEAD_OFFICE_RESET`,
    SET_SITE_LOCATIONS_HEADER:          `${PREFIX}_SET_SITE_LOCATIONS_HEADER`,
    SELECT_CASCADE_SECTIONS:            `${PREFIX}_SELECT_CASCADE_SECTIONS`,
    SELECT_CASCADE_SECTIONS_RESET:      `${PREFIX}_SELECT_CASCADE_SECTIONS_RESET`,
    FETCH_GENERATOR_TYPES:              `${PREFIX}_FETCH_GENERATOR_TYPES`,
    UPDATE_SELECTED_HEAD_OFFICE_NAME:   `${PREFIX}_UPDATE_SELECTED_HOF_NAME`,
    // ASSESSMENT_FETCH_PNP_TEMPLATES:     `${PREFIX}_ASSESSMENT_FETCH_PNP_TEMPLATES`,
    // NEW_ASSESSMENT_ASSIGNED_TO_HOF:     `${PREFIX}_NEW_ASSESSMENT_ASSIGNED_TO_HOF`,
    // NEW_ASSESSMENT_DETACH_FROM_HOF:     `${PREFIX}_NEW_ASSESSMENT_DETACH_FROM_HOF`,
    // NEW_ASSESSMENT_ITEM_RESET:          `${PREFIX}_NEW_ASSESSMENT_ITEM_RESET`,
};
